import ReactGA from 'react-ga';
import React, { Component } from 'react';
import { Route, withRouter } from 'react-router-dom';
// UA-64072279-1
ReactGA.initialize('UA-64072279-1'); // set real analytics id here

class ScrollToTopRoute extends Component {
    state = {
        scrollTop: false
    }
    componentDidUpdate(prevProps) {
        if (this.props.path === this.props.location.pathname && this.props.location.pathname !== prevProps.location.pathname) {
            ReactGA.pageview(this.props.location.pathname);
            this.setState({ scrollTop: true })
            // window.scrollTo(0, 0)
        }
    }

    render() {
        if (this.state.scrollTop) {
            window.scrollTo(0, 0)
        }
        const { component: Component, ...rest } = this.props;

        return <Route {...rest} render={props => (<Component {...props} />)} onU />;
    }
}

export default withRouter(ScrollToTopRoute);



// WEBPACK FOOTER //
// ./src/app/components/scroll-to-top-route/index.js